// app/providers.tsx (recommended pattern)
"use client";

import { PublicProvider } from "@/context/public-context";
import usePreventRefresh from "@/hooks/usePreventRefresh";
import FeatureFlagProvider from "@/providers/FeatureFlagsProvider";
import { SessionProvider } from "next-auth/react";

export function Providers({ children }: { children: JSX.Element }) {
  usePreventRefresh({});

  return (
    <SessionProvider>
      <FeatureFlagProvider>
        <PublicProvider>{children}</PublicProvider>
      </FeatureFlagProvider>
    </SessionProvider>
  );
}
